<template>                  
    <div class="row no-gutters "  >

        <div class="col-xl-2"></div>

        <div class="col-12 col-xl-8 bg-white p-2 p-md-5" >

            <div class="row"  >

                <div class="col-12 col-md-6">

                    <div class="p-5">
                        <h1 class="bold">404</h1>
                        <h1 class="mb-4" data-locale-html="system_notfound_1">{{$t('PAGES.system_notfound_1')}}</h1>
                        <p class="read-text" data-locale-html="system_notfound_2">{{$t('PAGES.system_notfound_2')}}</p>
                        <p class="read-text" data-locale-html="system_notfound_3">{{$t('PAGES.system_notfound_3')}}</p> 
                        <p class="read-text" data-locale-html="system_notfound_4">{{$t('PAGES.system_notfound_4')}}</p> 
                    </div>
                    <hr/>
                </div>
                        
                <div class="col-12 col-md-6">                                

                    <img src="https://cdnorquestrabootstrap.zeev.it/latest/assets/img/looking.svg" class="mt-3">

                </div>
                
        </div>

        <div class="col-xl-2"></div>

    </div>
</div>
  
</template>

<script>
export default { 
        name: 'PageNotFound'        
}
</script>